import { K8sAnalyzerNodesList } from "./k8s-analyzer-nodes-list/k8s-analyzer-nodes-list";

export function K8sAnalyzerNodesView() {
    return (
        <div className="w-full">
            <K8sAnalyzerNodesList />
        </div>
    );
}
